<template>
  <InputText
    :id="field.id"
    :value="modelValue || ''"
    @input="handleInput"
    @keypress="handleKeypress"
    @paste="handlePaste"
    :placeholder="field.config?.placeholder || ''"
  />
</template>

<script>
export default {
  name: 'AlphaOnlyInput',
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    field: {
      type: Object,
      required: true
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    // Regex for allowed characters: letters including Nordic æøåÆØÅ and space
    const allowedPattern = /^[a-zA-ZæøåÆØÅ ]$/;

    function handleKeypress(event) {
      const char = event.key;
      // Allow control keys (backspace, delete, arrows, etc.)
      if (char.length > 1) return;
      
      // Block if character is not allowed
      if (!allowedPattern.test(char)) {
        event.preventDefault();
      }
    }

    function handleInput(event) {
      const value = event.target.value;
      // Sanitize: remove any non-allowed characters that might have slipped through
      const sanitized = value.replace(/[^a-zA-ZæøåÆØÅ ]/g, '');
      
      if (sanitized !== value) {
        event.target.value = sanitized;
      }
      
      emit('update:modelValue', sanitized);
    }

    function handlePaste(event) {
      event.preventDefault();
      const pastedText = (event.clipboardData || window.clipboardData).getData('text');
      const sanitized = pastedText.replace(/[^a-zA-ZæøåÆØÅ ]/g, '');
      
      const input = event.target;
      const start = input.selectionStart;
      const end = input.selectionEnd;
      const currentValue = input.value;
      
      const newValue = currentValue.slice(0, start) + sanitized + currentValue.slice(end);
      input.value = newValue;
      
      emit('update:modelValue', newValue);
      
      // Set cursor position after pasted text
      const newCursorPos = start + sanitized.length;
      setTimeout(() => {
        input.setSelectionRange(newCursorPos, newCursorPos);
      }, 0);
    }

    return {
      handleKeypress,
      handleInput,
      handlePaste,
    };
  },
};
</script>
